<template lang="pug">
div
	.knowledge-base-boxes
		article.knowledge-base-box(v-for="(article, index) in newsList")
			h3.knowledge-base-box__title(:id="`a11y-news-box-${index}`") {{ article.title }}
			.knowledge-base-box__published-lockup.sf-text-fineprint
				.knowledge-base-box__tag-lockup
					span.sr-only Témái:
					a.knowledge-base-box__tag(v-for="(tag, index) in article.tags", @click.prevent="select(tag, true)") {{ tag.tag }}
						span(v-if="index != article.tags.length - 1") ,&nbsp;
					| &nbsp;
			.knowledge-base-box__text-content
				p {{ article.lead }}
			a#a11y-news-box-more-link.knowledge-base-box__more-link(:href="article.url", :aria-labelledby="`a11y-news-box-more-link a11y-news-box-${index}`") Elolvasom
</template>
<script>
import { mapState } from 'vuex';
import { required } from 'vuelidate/lib/validators';

export default {
	data() {
		return {};
	},
	props: {
		select: {
			type: Function,
			required
		}
	},
	computed: {
		...mapState('knowledgeBaseModule', ['technicalError', 'loading', 'newsList', 'tags'])
	}
};
</script>
